<div class="search-container">
  <div class="search-wrapper" [class.expanded]="isSearchOpen">
    <input
      type="text"
      [(ngModel)]="searchText"
      (ngModelChange)="filterPatients()"
      placeholder="Cerca paziente..."
      #searchInput
      [class.show]="isSearchOpen"
    />
    <div class="icon-wrapper" (click)="toggleSearch()">
      <mat-icon class="search-icon" [class.hide]="isSearchOpen"
        >search</mat-icon
      >
      <mat-icon class="close-icon" [class.show]="isSearchOpen">close</mat-icon>
    </div>
  </div>

  @if (isSearchOpen) {
    <div class="patients-panel">
      @if (isLoadingPatients) {
        <app-loader-standalone
          size="medium"
          class="loader"
        ></app-loader-standalone>
      }
      @for (patient of filteredPatients; track patient) {
        <div class="patient-item" (click)="navigateToPatientPage(patient)">
          {{ patient.first_name }} {{ patient.last_name }}
        </div>
      }
      @if (filteredPatients.length === 0) {
        <div class="no-results">Nessun paziente trovato</div>
      }
    </div>
  }
</div>
